module.exports = __webpack_public_path__ + "static/media/checkbox_on.544f8c53.svg";